<template>
<div class="container-fluid">
  <vs-row vs-type="flex" style="background-color: green;">
  <vs-col
    vs-order="3"
    vs-type="flex" vs-justify="center" vs-align="center" vs-w="3">
      1 / order 3
  </vs-col>
  <vs-col
    vs-order="1"
    vs-type="flex" vs-justify="center" vs-align="center" vs-w="3">
      2 / order 1
  </vs-col>
  <vs-col
    vs-order="4"
    vs-type="flex" vs-justify="center" vs-align="center" vs-w="3">
      3 / order 4
  </vs-col>
  <vs-col
    vs-order="2"
    vs-type="flex" vs-justify="center" vs-align="center" vs-w="3">
      4 / order 2
  </vs-col>
</vs-row>
  


    <vs-table stripe :data="alertlist">
      <template slot="header">
        <h3 style="color: #D03B30">
          <vs-icon icon="new_releases"></vs-icon> Notification
        </h3>
      </template>
      <template slot="thead">
        <vs-th style="padding: 0px">
          Alert Name
        </vs-th>
        <vs-th style="padding: 0px">
          Condition
        </vs-th>
        <vs-th style="padding: 0px">
          Sensor Name
        </vs-th>
        <vs-th style="padding: 0px">
          Reading Data
        </vs-th>
        <vs-th style="padding: 0px">
          Timestamp
        </vs-th>
      </template>

      <template slot-scope="{data}">
        <vs-tr :state="indextr == 0?'danger':null" :key="indextr" v-for="(tr, indextr) in data" >
          <vs-td>
            {{data[indextr].name}}
          </vs-td>
          <vs-td>
            {{data[indextr].con}}
          </vs-td>
          <vs-td>
            {{data[indextr].sensname}}
          </vs-td>
          <vs-td>
            {{data[indextr].data}}
          </vs-td>
          <vs-td>
            {{data[indextr].timestamp}}
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>
</div>
</template>

<script>
export default {
  name: "AlertList",
  data: () => ({
    nwlist: [],
    sensorlist: [],
    alertlist: []
    // alertlist: [{"name":"Test Alert","con":"Temperature > 25","sensname":"Office Temp","data":"26C","timestamp":"2020-8-13 16:23:45"}]
  }),
  methods: {
  },
  created() {
  }
}
</script>

<style scoped>
.span {
  font-size: 14px;
}
.thead {
  padding: 0px;
}
</style>